import store from '@/store'
import {
  connectionService,
  browserUtils,
  DEVICE_CREATE_URI,
  DEVICE_DELETE_URI,
  DEVICE_FIND_URI,
  DEVICE_LOGOUT_URI
} from '@leapsight/styleguide'
import {DEVICE_IDENTIFIER} from "@/constants/devices";

const prepareToStore = () => {
  const data = {}
  data.account_id = connectionService.getAccountId()
  data.user_id = connectionService.getBusinessUserId()
  data.info = {
    name: browserUtils.name,
    make: browserUtils.make,
    model: browserUtils.model,
    system_name: browserUtils.system_name,
    system_version: browserUtils.system_version,
    app_installation_id: browserUtils.app_installation_id,
    app_version_id: browserUtils.app_version_id,
    identifier: localStorage.getItem(DEVICE_IDENTIFIER)
  }
  data.config = {
    push_notifications_enabled: true,
    tracking_enabled: true
  }

  return data
}


const create = () => {
  return new Promise((resolve, reject) => {
    const connection = store.getters['auth/connection']
    const args = [prepareToStore()]
    const kwArgs = connectionService.createkwArgs()
    const options = {}

    connection.session
    .call(DEVICE_CREATE_URI, args, kwArgs, options)
    .then(
      response => {
        resolve(response)
      },
      wampError => {
        console.error(wampError)
        reject(wampError)
      }
    )
    .catch(error => {
      console.error(error)
      reject(error)
    })
  })
}

const deleteDevice = (id) => {
  return new Promise((resolve, reject) => {
    const connection = store.getters['auth/connection']
    const args = [id]
    const kwArgs = connectionService.createkwArgs()
    const options = {}

    connection.session
    .call(DEVICE_DELETE_URI, args, kwArgs, options)
    .then(
      response => {
        resolve(response)
      },
      wampError => {
        console.error(wampError)
        reject(wampError)
      }
    )
    .catch(error => {
      console.error(error)
      reject(error)
    })
  })
}
  
const find = () => {
  return new Promise((resolve, reject) => {
    const connection = store.getters['auth/connection']
    const accountId = connectionService.getAccountId()
    const userId = connectionService.getBusinessUserId()
    const args = [{ account_id: accountId, user_id: userId }]
    const security = connectionService.createkwArgs()
    const kwArgs = {
      ...security
    }
    const options = {}

    connection.session
    .call(DEVICE_FIND_URI, args, kwArgs, options)
    .then(
      response => {
        resolve(response)
      },
      wampError => {
        console.error(wampError)
        reject(wampError)
      }
    )
    .catch(error => {
      console.error(wampError)
      reject(error)
    })
  })
}

const logoutDevice = ({ deviceId }) => {
  return new Promise((resolve, reject) => {
    const connection = store.getters['auth/connection']
    const userId = connectionService.getBusinessUserId()
    const args = {}
    if (deviceId) args.device_id = deviceId
    else args.user_id = userId

    const security = connectionService.createkwArgs()
    const kwArgs = {
      ...security
    }
    const options = {}

    connection.session
    .call(DEVICE_LOGOUT_URI, [args], kwArgs, options)
    .then(
      response => {
        resolve(response)
      },
      wampError => {
        console.error(wampError)
        reject(wampError)
      }
    )
    .catch(error => {
      console.error(error)
      reject(error)
    })
  })
}

const updateToken = () => {
  return new Promise((resolve, reject) => {})
}

export default {
  create,
  deleteDevice,
  find,
  logoutDevice,
  updateToken
}
